<loader-modal *ngIf="previewScopeLoading$ | async"></loader-modal>

<div
  *ngIf="currentChangeRequest"
  class="change-request pt-2">
  <div class="change-request-content">
    <scope-ui-options-menu
      [has-privilege]="Privilege.SCOPE__CREATE"
      [menuOptions]="scopeActions"
      buttonText="Create new"
      class="change-request-create" />

    <scope-ui-tabs
      fontSize="14px"
      class="change-request-tabs"
      (onSelect)="selectTab($event)"
      (onInit)="setDefaultTab($event)">
      <scope-ui-tab
        [tabTitle]="ChangeRequestTab.OVERVIEW"
        class="scope-tab white-background overflow-auto"
        [active]="currentTab === ChangeRequestTabRoutes[ChangeRequestTab.OVERVIEW]">
        <change-request-overview
          *ngIf="currentTab === ChangeRequestTab.OVERVIEW && currentScope"
          [currentScope]="currentScope"
          [currentChangeRequest]="currentChangeRequest"
          [sections]="sortedSections$ | async"
          [deliverables]="mappedDeliverables$ | async"
          [cdnConfig]="cdnConfig"
          [mainColumnClass]="mainColumnClass"
          [componentMainColumnClass]="componentMainColumnClass"
          [roleMainColumnClass]="roleMainColumnClass"
          (onAddDeliverable)="addDeliverable($event)"
          (onDeleteDeliverable)="deleteDeliverable($event)"
          (onFetchDeliverable)="fetchDeliverable($event)"
          (onEditDeliverable)="editDeliverable($event)"
          (onDeleteComponent)="deleteComponent($event)" />
      </scope-ui-tab>

      <scope-ui-tab
        [tabTitle]="ChangeRequestTab.TRACKED"
        class="scope-tab white-background overflow-auto"
        [active]="currentTab === ChangeRequestTabRoutes[ChangeRequestTab.TRACKED]">
        <change-request-tracked
          *ngIf="currentTab === ChangeRequestTab.TRACKED"
          [currentScope]="currentScope"
          [currentChangeRequest]="currentChangeRequest"
          [changeItemsMap]="changeItemsMap$ | async"
          [sections]="sortedSections$ | async"
          [deliverables]="mappedTrackedDeliverables$ | async"
          [cdnConfig]="cdnConfig"
          [mainColumnClass]="mainColumnClass"
          [componentMainColumnClass]="componentMainColumnClass"
          [roleMainColumnClass]="roleMainColumnClass"
          (onFetchDeliverable)="fetchDeliverable($event)"
          (onDeleteDeliverable)="deleteDeliverable($event)"
          (onEditDeliverable)="editDeliverable($event)"
          (onDeleteComponent)="deleteComponent($event)" />
      </scope-ui-tab>

      <scope-ui-tab
        [tabTitle]="ChangeRequestTab.LIST"
        class="scope-tab white-background overflow-auto"
        [active]="currentTab === ChangeRequestTabRoutes[ChangeRequestTab.LIST]">
        <change-request-list *ngIf="currentTab === ChangeRequestTab.LIST" />
      </scope-ui-tab>
    </scope-ui-tabs>
  </div>

  <change-request-approval-flow
    *ngIf="currentChangeRequest"
    [has-setting]="ApplicationSetting.CHANGE_REQUEST && ApplicationSetting.SCOPE__ENABLE_CHANGE_REQUEST"
    [changeRequest]="currentChangeRequest"
    [currentUser]="loggedInUser"
    [parentScope]="currentScope"
    (onTraffic)="openTrafficModal()" />
</div>
